import { Tracking } from './Tracking';

export enum PurchaseTrackingStage {
    CLICK = 'Click',
    SUCCESS = 'Success',
    CANCEL = 'Cancel',
    ERROR = 'Error',
}

export default class ShopTracking {
    public static trackPurchase(productId: string, stage: PurchaseTrackingStage) {
        Tracking.addTrack({
            event: 'Design',
            dimension1: `Shop_${productId}_${stage}`,
        });
    }

    public static trackGift() {
        Tracking.addTrack({
            event: 'Design',
            dimension1: `Shop_Gift_Claim`,
        });
    }
}
